var map = {
	"./add_icon.svg": "./src/assets/icons/svg/add_icon.svg",
	"./add_question_judge_icon.svg": "./src/assets/icons/svg/add_question_judge_icon.svg",
	"./add_question_multi_icon.svg": "./src/assets/icons/svg/add_question_multi_icon.svg",
	"./add_question_single_icon.svg": "./src/assets/icons/svg/add_question_single_icon.svg",
	"./annular.svg": "./src/assets/icons/svg/annular.svg",
	"./arrow-right.svg": "./src/assets/icons/svg/arrow-right.svg",
	"./arrow_down.svg": "./src/assets/icons/svg/arrow_down.svg",
	"./arrow_up.svg": "./src/assets/icons/svg/arrow_up.svg",
	"./bashboard_account_mangger.svg": "./src/assets/icons/svg/bashboard_account_mangger.svg",
	"./bashboard_car_manger_help.svg": "./src/assets/icons/svg/bashboard_car_manger_help.svg",
	"./bashboard_car_manger_qy.svg": "./src/assets/icons/svg/bashboard_car_manger_qy.svg",
	"./bashboard_clique_manger.svg": "./src/assets/icons/svg/bashboard_clique_manger.svg",
	"./bashboard_company_down.svg": "./src/assets/icons/svg/bashboard_company_down.svg",
	"./bashboard_company_flat.svg": "./src/assets/icons/svg/bashboard_company_flat.svg",
	"./bashboard_company_up.svg": "./src/assets/icons/svg/bashboard_company_up.svg",
	"./bashboard_datas_manger.svg": "./src/assets/icons/svg/bashboard_datas_manger.svg",
	"./bashboard_dynamic_monitor_icon.svg": "./src/assets/icons/svg/bashboard_dynamic_monitor_icon.svg",
	"./bashboard_equipments_manger.svg": "./src/assets/icons/svg/bashboard_equipments_manger.svg",
	"./bashboard_header_location_study.svg": "./src/assets/icons/svg/bashboard_header_location_study.svg",
	"./bashboard_inboxs_manger.svg": "./src/assets/icons/svg/bashboard_inboxs_manger.svg",
	"./bashboard_insurance_manger.svg": "./src/assets/icons/svg/bashboard_insurance_manger.svg",
	"./bashboard_lessions_manger.svg": "./src/assets/icons/svg/bashboard_lessions_manger.svg",
	"./bashboard_my_org.svg": "./src/assets/icons/svg/bashboard_my_org.svg",
	"./bashboard_number_manger.svg": "./src/assets/icons/svg/bashboard_number_manger.svg",
	"./bashboard_off_line.svg": "./src/assets/icons/svg/bashboard_off_line.svg",
	"./bashboard_order_manger.svg": "./src/assets/icons/svg/bashboard_order_manger.svg",
	"./bashboard_org_manger.svg": "./src/assets/icons/svg/bashboard_org_manger.svg",
	"./bashboard_outboxs_manger.svg": "./src/assets/icons/svg/bashboard_outboxs_manger.svg",
	"./bashboard_plan_add_qy.svg": "./src/assets/icons/svg/bashboard_plan_add_qy.svg",
	"./bashboard_plan_manger.svg": "./src/assets/icons/svg/bashboard_plan_manger.svg",
	"./bashboard_plan_progress_qy.svg": "./src/assets/icons/svg/bashboard_plan_progress_qy.svg",
	"./bashboard_receive_msg.svg": "./src/assets/icons/svg/bashboard_receive_msg.svg",
	"./bashboard_refresh.svg": "./src/assets/icons/svg/bashboard_refresh.svg",
	"./bashboard_repos_manger.svg": "./src/assets/icons/svg/bashboard_repos_manger.svg",
	"./bashboard_save_ledger_icon.svg": "./src/assets/icons/svg/bashboard_save_ledger_icon.svg",
	"./bashboard_send_msg.svg": "./src/assets/icons/svg/bashboard_send_msg.svg",
	"./bashboard_studnet_manger.svg": "./src/assets/icons/svg/bashboard_studnet_manger.svg",
	"./bashboard_studnet_manger_dls.svg": "./src/assets/icons/svg/bashboard_studnet_manger_dls.svg",
	"./bashboard_study_ticket_icon.svg": "./src/assets/icons/svg/bashboard_study_ticket_icon.svg",
	"./bashboard_user_address.svg": "./src/assets/icons/svg/bashboard_user_address.svg",
	"./bashboard_user_company.svg": "./src/assets/icons/svg/bashboard_user_company.svg",
	"./bashboard_user_identy.svg": "./src/assets/icons/svg/bashboard_user_identy.svg",
	"./batch_activate_no_supported_icon.svg": "./src/assets/icons/svg/batch_activate_no_supported_icon.svg",
	"./box_bottom_left_icon.svg": "./src/assets/icons/svg/box_bottom_left_icon.svg",
	"./box_bottom_right_icon.svg": "./src/assets/icons/svg/box_bottom_right_icon.svg",
	"./box_top_left_icon.svg": "./src/assets/icons/svg/box_top_left_icon.svg",
	"./box_top_right_icon.svg": "./src/assets/icons/svg/box_top_right_icon.svg",
	"./dashboard_cert_authen_unfinished.svg": "./src/assets/icons/svg/dashboard_cert_authen_unfinished.svg",
	"./default-head.svg": "./src/assets/icons/svg/default-head.svg",
	"./delete_icon.svg": "./src/assets/icons/svg/delete_icon.svg",
	"./edit_icon.svg": "./src/assets/icons/svg/edit_icon.svg",
	"./equipment-shop.svg": "./src/assets/icons/svg/equipment-shop.svg",
	"./equipment.svg": "./src/assets/icons/svg/equipment.svg",
	"./exit-fullscreen.svg": "./src/assets/icons/svg/exit-fullscreen.svg",
	"./expand_icon.svg": "./src/assets/icons/svg/expand_icon.svg",
	"./finger_icon.svg": "./src/assets/icons/svg/finger_icon.svg",
	"./full-screen.svg": "./src/assets/icons/svg/full-screen.svg",
	"./fullscreen.svg": "./src/assets/icons/svg/fullscreen.svg",
	"./header_icon_logout.svg": "./src/assets/icons/svg/header_icon_logout.svg",
	"./header_icon_offline.svg": "./src/assets/icons/svg/header_icon_offline.svg",
	"./import_dia_icon.svg": "./src/assets/icons/svg/import_dia_icon.svg",
	"./login_box_account_icon.svg": "./src/assets/icons/svg/login_box_account_icon.svg",
	"./login_box_pwd_icon.svg": "./src/assets/icons/svg/login_box_pwd_icon.svg",
	"./login_template_icon_phone_black.svg": "./src/assets/icons/svg/login_template_icon_phone_black.svg",
	"./login_template_one_kf_icon.svg": "./src/assets/icons/svg/login_template_one_kf_icon.svg",
	"./menu_bill_manager.svg": "./src/assets/icons/svg/menu_bill_manager.svg",
	"./menu_business_manager.svg": "./src/assets/icons/svg/menu_business_manager.svg",
	"./menu_cert_print.svg": "./src/assets/icons/svg/menu_cert_print.svg",
	"./menu_course_manager.svg": "./src/assets/icons/svg/menu_course_manager.svg",
	"./menu_dashboard.svg": "./src/assets/icons/svg/menu_dashboard.svg",
	"./menu_data_statics.svg": "./src/assets/icons/svg/menu_data_statics.svg",
	"./menu_document.svg": "./src/assets/icons/svg/menu_document.svg",
	"./menu_exam_manager.svg": "./src/assets/icons/svg/menu_exam_manager.svg",
	"./menu_finance_manager.svg": "./src/assets/icons/svg/menu_finance_manager.svg",
	"./menu_message_manager.svg": "./src/assets/icons/svg/menu_message_manager.svg",
	"./menu_my_org.svg": "./src/assets/icons/svg/menu_my_org.svg",
	"./menu_news_manager.svg": "./src/assets/icons/svg/menu_news_manager.svg",
	"./menu_org_manager.svg": "./src/assets/icons/svg/menu_org_manager.svg",
	"./menu_plan_manager.svg": "./src/assets/icons/svg/menu_plan_manager.svg",
	"./menu_pre_work.svg": "./src/assets/icons/svg/menu_pre_work.svg",
	"./menu_report.svg": "./src/assets/icons/svg/menu_report.svg",
	"./menu_safe_meeting.svg": "./src/assets/icons/svg/menu_safe_meeting.svg",
	"./menu_safe_train.svg": "./src/assets/icons/svg/menu_safe_train.svg",
	"./menu_special_train.svg": "./src/assets/icons/svg/menu_special_train.svg",
	"./menu_student_manager.svg": "./src/assets/icons/svg/menu_student_manager.svg",
	"./menu_suggest_manager.svg": "./src/assets/icons/svg/menu_suggest_manager.svg",
	"./menu_sys_manager.svg": "./src/assets/icons/svg/menu_sys_manager.svg",
	"./menu_target_train.svg": "./src/assets/icons/svg/menu_target_train.svg",
	"./menu_three_check.svg": "./src/assets/icons/svg/menu_three_check.svg",
	"./msg_tip_do_item.svg": "./src/assets/icons/svg/msg_tip_do_item.svg",
	"./news_heart_icon.svg": "./src/assets/icons/svg/news_heart_icon.svg",
	"./news_like_count.svg": "./src/assets/icons/svg/news_like_count.svg",
	"./news_scan_icon.svg": "./src/assets/icons/svg/news_scan_icon.svg",
	"./no_show_icon.svg": "./src/assets/icons/svg/no_show_icon.svg",
	"./pay_mode_setting_pdf.svg": "./src/assets/icons/svg/pay_mode_setting_pdf.svg",
	"./plan_pay_right_icon.svg": "./src/assets/icons/svg/plan_pay_right_icon.svg",
	"./plan_template_add_icon.svg": "./src/assets/icons/svg/plan_template_add_icon.svg",
	"./play_count_icon.svg": "./src/assets/icons/svg/play_count_icon.svg",
	"./question_type_change.svg": "./src/assets/icons/svg/question_type_change.svg",
	"./question_type_judge.svg": "./src/assets/icons/svg/question_type_judge.svg",
	"./question_type_multiple.svg": "./src/assets/icons/svg/question_type_multiple.svg",
	"./question_type_single.svg": "./src/assets/icons/svg/question_type_single.svg",
	"./real_authen_unfinished.svg": "./src/assets/icons/svg/real_authen_unfinished.svg",
	"./role_production_gou.svg": "./src/assets/icons/svg/role_production_gou.svg",
	"./scan_eye.svg": "./src/assets/icons/svg/scan_eye.svg",
	"./select_default_admin.svg": "./src/assets/icons/svg/select_default_admin.svg",
	"./select_user_all.svg": "./src/assets/icons/svg/select_user_all.svg",
	"./setting_blu.svg": "./src/assets/icons/svg/setting_blu.svg",
	"./shrink_icon.svg": "./src/assets/icons/svg/shrink_icon.svg",
	"./sidebar-expand.svg": "./src/assets/icons/svg/sidebar-expand.svg",
	"./sidebar-unexpand.svg": "./src/assets/icons/svg/sidebar-unexpand.svg",
	"./statictis_people_manger_curve.svg": "./src/assets/icons/svg/statictis_people_manger_curve.svg",
	"./student_face_check_manger.svg": "./src/assets/icons/svg/student_face_check_manger.svg",
	"./student_train_add_icon.svg": "./src/assets/icons/svg/student_train_add_icon.svg",
	"./switch.svg": "./src/assets/icons/svg/switch.svg",
	"./system_param_manger.svg": "./src/assets/icons/svg/system_param_manger.svg",
	"./template_update_name_icon.svg": "./src/assets/icons/svg/template_update_name_icon.svg",
	"./three_check_all_qualified_icon.svg": "./src/assets/icons/svg/three_check_all_qualified_icon.svg",
	"./three_check_all_un_qualified_icon.svg": "./src/assets/icons/svg/three_check_all_un_qualified_icon.svg",
	"./three_check_qualified_icon.svg": "./src/assets/icons/svg/three_check_qualified_icon.svg",
	"./three_check_qualified_un_icon.svg": "./src/assets/icons/svg/three_check_qualified_un_icon.svg",
	"./time.svg": "./src/assets/icons/svg/time.svg",
	"./trade-charge.svg": "./src/assets/icons/svg/trade-charge.svg",
	"./trade-enterprise-payment.svg": "./src/assets/icons/svg/trade-enterprise-payment.svg",
	"./trade-free.svg": "./src/assets/icons/svg/trade-free.svg",
	"./trade-order-total.svg": "./src/assets/icons/svg/trade-order-total.svg",
	"./trade-personal-payment.svg": "./src/assets/icons/svg/trade-personal-payment.svg",
	"./use_count_icon.svg": "./src/assets/icons/svg/use_count_icon.svg",
	"./user_real_auth.svg": "./src/assets/icons/svg/user_real_auth.svg",
	"./view_all_icon.svg": "./src/assets/icons/svg/view_all_icon.svg",
	"./waring_icon.svg": "./src/assets/icons/svg/waring_icon.svg",
	"./wraing_export_icon.svg": "./src/assets/icons/svg/wraing_export_icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync \\.svg$";